import React from 'react';
import ForgotPasswordForm, {
  Props
} from '~/App/shared/components/ForgotPassword';
import ComponentPadding from '~/App/shared/components/Layout/ComponentPadding';

const ForgotPassword = (props: Props) => {
  return (
    <ComponentPadding>
      <ForgotPasswordForm {...props} />
    </ComponentPadding>
  );
};

export default ForgotPassword;
